import React from 'react';
import classNames from 'classnames';
import FacebookMessengerIcon from '@/assets/icons/facebook-messenger.svg?react';
import InstagramIcon from '@/assets/icons/instagram.svg?react';
import LineIcon from '@/assets/icons/line.svg?react';
import TelegramIcon from '@/assets/icons/telegram.svg?react';
import ViberIcon from '@/assets/icons/viber.svg?react';
import WechatIcon from '@/assets/icons/wechat.svg?react';
import WhatsappIcon from '@/assets/icons/whatsapp.svg?react';

export interface ChannelButtonProps {
  platform:
    | 'whatsapp'
    | 'facebook'
    | 'instagram'
    | 'wechat'
    | 'line'
    | 'telegram'
    | 'viber';
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

const ICON_MAP = {
  whatsapp: <WhatsappIcon width="20" height="20" title="WhatsApp" />,
  facebook: (
    <FacebookMessengerIcon width="20" height="20" title="Facebook Messenger" />
  ),
  instagram: <InstagramIcon width="20" height="20" title="Instagram" />,
  wechat: <WechatIcon width="20" height="20" title="WeChat" />,
  line: <LineIcon width="20" height="20" title="Line" />,
  telegram: <TelegramIcon width="20" height="20" title="Telegram" />,
  viber: <ViberIcon width="20" height="20" title="Viber" />,
};

const ChannelButton: React.FC<ChannelButtonProps> = ({
  platform,
  label,
  onClick,
  disabled = false,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={classNames({
        'sf:w-full sf:flex sf:items-center sf:gap-3 sf:p-3 sf:border sf:border-gray-200 sf:rounded sf:bg-white sf:transition-all sf:duration-200 sf:disabled:cursor-not-allowed sf:cursor-pointer':
          true,
        'sf:opacity-50': disabled,
        'sf:hover:bg-gray-50 sf:hover:border-gray-300 sf:active:bg-gray-100':
          !disabled,
      })}
      type="button"
    >
      {ICON_MAP[platform]}
      <span className="sf:text-sm sf:font-normal sf:text-gray-900">
        {label}
      </span>
    </button>
  );
};

export default ChannelButton;
